import {Injectable} from '@angular/core';
import {AbstractModelService} from "../model/abstract-model.service";
import {ApiClientService} from "../api-client/api-client.service";
import {UserEvent} from '../../models/user-event';

@Injectable({
  providedIn: 'root'
})
export class UserEventService extends AbstractModelService<UserEvent> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/user-event', UserEvent);
  }

}
